/** Value of `nextMenuIndex` when the key does not move the focus. */
export const NO_MOVE = -1;

function wrap(index: number, count: number): number {
  return count === 0 ? NO_MOVE : (index + count) % count;
}

/**
 * Index of the item a key moves the focus to in a menu of `count` enabled items, or `NO_MOVE`.
 * The arrows wrap around; Home and End jump to the ends. `current` is -1 when no item has focus.
 */
export function nextMenuIndex(key: string, current: number, count: number): number {
  switch (key) {
    case "ArrowDown":
      return wrap(current + 1, count);
    case "ArrowUp":
      return wrap(current - 1, count);
    case "Home":
      return 0;
    case "End":
      return count - 1;
    default:
      return NO_MOVE;
  }
}
